import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import {
  isCrmLicense,
  formatLicenseInfo,
  specialtyLineDisplay,
  getProfessionalCrmSuffix,
  isAnnounceableSpecialty,
  MAX_DISPLAYED_SPECIALTIES,
} from '@/utils/professional/professional-license.util';
import { SchedulesSearchProfessionalLicenses } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

interface SearchEntitySpecialtiesProps {
  professional: {
    licenses: SchedulesSearchProfessionalLicenses[];
    gender?: string;
    honorific?: string;
  };
}

export const EntitySpecialtiesAndRqe = ({ professional }: SearchEntitySpecialtiesProps) => {
  const { licenses, gender, honorific } = professional;

  const validLicenses = licenses.filter((license) => license.professionalLicenseRecord);

  if (validLicenses.length === 0) {
    return null;
  }

  const registration = validLicenses[0];
  const isCrm = isCrmLicense(registration);
  const crmSuffix = isCrm ? getProfessionalCrmSuffix({ gender, honorific }) : undefined;
  const displayedSpecialties = isCrm
    ? validLicenses
        .filter((license) =>
          license.isDisplayed && isAnnounceableSpecialty(license.specialtyName, license.specialistQualificationRecord))
        .slice(0, MAX_DISPLAYED_SPECIALTIES)
    : [];

  return (
    <div className="flex-grow" data-testid={DataTestIdEnum.ENTITY_SPECIALTIES_AND_RQE}>
      <Typography
        variant={TypographyVariant.MEDIUM_BODY_TEXT}
        className="text-gray-700"
        data-testid={DataTestIdEnum.ENTITY_SPECIALTIES_AND_RQE_LINE}
      >
        {formatLicenseInfo(registration, crmSuffix)}
      </Typography>
      {displayedSpecialties.map((license) => (
        <Typography
          variant={TypographyVariant.MEDIUM_BODY_TEXT}
          className="text-gray-700"
          data-testid={DataTestIdEnum.ENTITY_SPECIALTIES_AND_RQE_LINE}
          key={`${license.professionalLicenseRecord}-${license.specialtyName}`}
        >
          {specialtyLineDisplay(license)}
        </Typography>
      ))}
    </div>
  );
};
